<template>
  <div>
    <b-modal
      id="modalCarStop"
      title="รถจอด / อุบัติเหตุ"
      size="xl"
      ok-only
      ok-title="กลับ"
    >
      <b-row class="text3">
        <!-- สัดส่วนเหตุการณ์ต่างๆ -->
        <b-col
          lg="12"
          md="12"
          xs="12"
        >
          <b-col>
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 1503 586"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.5 559.013L24.2231 585.5L1385.22 583.934H1502.5V546.858V509.282V298.697V88.1126V28.738L1478.78 2.5H0.5V39.5764V77.1528V506.15V559.013Z"
                stroke="#00B058"
              />
              <path
                d="M54 584H24.6821L2 561V535"
                stroke="#00B058"
                stroke-width="4"
              />
              <path
                d="M1449 2H1478.32L1501 25V51"
                stroke="#00B058"
                stroke-width="4"
              />
              <foreignObject
                width="100%"
                height="100%"
                x="25"
                y="25"
              >
                <div>
                  <span style="font-size:20px; color: #fff;">สถิติรถจอด/อุบัติเหตุ ภายใน 7 วัน</span>
                </div>
              </foreignObject>
              <foreignObject
                x="20"
                y="50"
                width="100%"
                height="100%"
                color="#ffffff"
                font-size="20"
              >
                <div class="mt-2">
                  <app-echar-line
                    :option-data="option"
                  />
                </div>
              </foreignObject>
            </svg>
          </b-col>
        </b-col>
      </b-row>
      <br>
      <b-row class="text3">
        <b-col
          lg="12"
          md="12"
          class="mt-1"
        >
          <h2>รายงานความผิดปกติบนท้องถนน</h2>
        </b-col>
        <b-col
          lg="2"
          md="2"
          class="d-flex align-items-center justify-content-start mb-1"
        >
          <label>ค้นหา</label>
          <b-input-group
            size="sm"
            style="padding-left:5px;"
          >
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="ป้อนคำค้นหา"
              label-cols-sm="12"
              label-cols-md="2"
              label-cols-lg="2"
              style=" background-color:rgba(0,0,0, 0.6);"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''"
              >
                ล้าง
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12">
          <b-table
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(row_num)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(FilePath)="data">
              <b-img
                :src="data.item.FilePath"
                width="200px"
                fluid
                @click="showImg(data.item.FilePath)"
              />
            </template>
          </b-table>
        </b-col>
        <b-col
          cols="12"
        >
          <b-card-body class="d-flex justify-content-between flex-wrap pt-1">
            <!-- page length -->
            <b-form-group
              label="Per Page"
              label-cols="6"
              label-align="left"
              label-size="sm"
              label-for="sortBySelect"
              class="text-nowrap mb-md-0 mr-1"
            >
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                inline
                :options="pageOptions"
              />
            </b-form-group>

            <!-- pagination -->
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </div>
          </b-card-body>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BTable, BPagination, BInputGroup, BInputGroupAppend, BFormInput, BButton,
  BFormGroup, BFormSelect, BCardBody, BImg,
} from 'bootstrap-vue'
import axios from '@axios'
import AppEcharLine from '@/views/analytic120/modalAnalytic/modalgaraphLineAG/modalAppEchartLineAG.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BButton,
    BFormGroup,
    BFormSelect,
    BCardBody,
    AppEcharLine,
    // BLink,
    BImg,
    // BBadge,
  },
  data() {
    return {
      option: {
        xAxisData: [],
        series: [
          {
            name: 'รถหยุด',
            type: 'line',
            areaStyle: {
              color: '#FF5733',
            },
            color: '#FF5733',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
        ],
      },
      fields: [
        {
          key: 'row_num',
          label: 'ลำดับ',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'Camera_Desc',
          label: 'จุดติดตั้ง',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'CAMID',
          label: 'กล้องที่',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'DATE_TIME',
          label: 'วันที่',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'Detection_Type',
          label: 'เหตุการณ์',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'FilePath',
          label: 'ภาพเหตุการณ์',
          class: 'text-center',
        },
      ],
      items: [],
      perPage: 25,
      pageOptions: [25, 50, 75, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],

      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)
      return this.fieldsSpeaker
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getModalbarChartCounting()
    this.getModalTableAnalytic()
    this.interval = setInterval(() => {
      this.getModalTableAnalytic()
    }, 300000)
  },
  methods: {
    getModalbarChartCounting() {
      axios
        .post('/graphCarStopTotal', { department: this.userData.department })
        .then(response => {
          this.xAxisData = []
          this.xAxisData[0] = response.data
          this.xAxisData[0].forEach(value => {
            this.option.xAxisData.push(value.Date_Th)
            this.option.series[0].data.push(value.Car_Stop)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    getModalTableAnalytic() {
      axios
        .post('/tableCarStopTotal', { department: this.userData.department })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
          this.camid = response.data.CAMID
        })
        .catch(error => {
          console.log(error)
        })
    },
    showImg(img) {
      this.$swal({
        imageUrl: img,
        imageAlt: 'Custom image',
        width: 800,
        background: 'hsla(0, 100%, 100%, 0)',
        showCancelButton: false,
        showConfirmButton: false,
        showCloseButton: true,
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss" scoped>
// .table-responsive{
//    font-size: 16px;
// }
.text3 {
    font-family: 'Sarabun';
  }
</style>
